import { render, staticRenderFns } from "./ReservationOpenTime.vue?vue&type=template&id=2f5361d4&scoped=true&"
import script from "./ReservationOpenTime.vue?vue&type=script&lang=js&"
export * from "./ReservationOpenTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5361d4",
  null
  
)

export default component.exports